import { render, staticRenderFns } from "./businessUsage.vue?vue&type=template&id=1fa153e6&"
import script from "./businessUsage.vue?vue&type=script&lang=js&"
export * from "./businessUsage.vue?vue&type=script&lang=js&"
import style0 from "./businessUsage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports